import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { RolesCreate } from './RolesCreate/RolesCreate';
import { RolesEdit } from './RolesEdit/RolesEdit';
import { RolesList } from './RolesList/RolesList';
import { RolesShow } from './RolesShow/RolesShow';

export const rolesResource: ResourceProps = {
  name: Resources.Roles,
  create: RolesCreate,
  edit: RolesEdit,
  list: RolesList,
  show: RolesShow,
};
